import { escapeRegularExpressionSpecialCharacters } from '.';

/**
 * Returns true if string matches a tokenised search term.
 * For a "tokenised" search we ignore every non-alphanumeric character, accept partial matches, and match case-insensitively.
 * See QEST.Contracts.QueryModelHelpers.ParseQueryModelSearch
 *
 * @param {string} [s] - The string to test
 * @param {string} [search] - The search term
 */
export const matchesTokenisedSearchString = (s: string, search: string) =>
  new RegExp(
    '.*' +
      search
        ?.trim()
        .split(/[^a-zA-Z0-9]+/)
        .map(escapeRegularExpressionSpecialCharacters)
        .join('.*') +
      '.*',
    'i'
  ).test(s);
